import { configureStore } from '@reduxjs/toolkit';
import coursesReducer from './slices/coursesSlice';
import facultyReducer from './slices/facultySlice';
import resultsReducer from './slices/resultsSlice';
import galleryReducer from './slices/gallerySlice';
import enquiryReducer from './slices/enquirySlice';
import enquiriesReducer from './slices/enquiriesSlice';
import contactReducer from './slices/contactSlice';

export const store = configureStore({
    reducer: {
        courses: coursesReducer,
        faculty: facultyReducer,
        results: resultsReducer,
        gallery: galleryReducer,
        enquiry: enquiryReducer,
        enquiries: enquiriesReducer,
        contact: contactReducer,
    },
});